module.exports = __webpack_public_path__ + "img/6.55dd6adc.png";